import Vue from 'vue';
import '@/plugins/vuetify';
import App from '@/App.vue';
import router from '@/router';
import eventBus from '@/common/bus';
import '../public/assets/css/style.css';
import store from '@/store';
import StoreVuexModule from '@/stores/StoreVuexModule';
import { getModule } from 'vuex-module-decorators';
import { load } from 'recaptcha-v3';
import { loadAnalytics } from '@/services/segment.service';

Vue.config.productionTip = false;
Vue.config.errorHandler = (err, vm, info) => {
    // display errors
    const errorMsg: string = 'Component: ' + vm.$options.name + '\n' + 'Method: ' + info + '\n' + 'Error: ' + err;
    eventBus.$emit('errorHandler', errorMsg);
};

// setup the application
(async () => {
    function setAppLoadingMessage(message: string, hideSpinner: boolean = false) {
        const textElem = document.getElementById('appLoadingMsg');
        if (textElem) {
            textElem.innerText = message;
        }

        const spinnerElem = document.getElementById('appLoadingSpinner');
        if (spinnerElem) {
            spinnerElem.style.display = hideSpinner ? 'none' : 'block';
        }
    }

    const storeModule = getModule(StoreVuexModule, store);
    try {
        const res = await storeModule.loadStoreFromSettings();
        if (res[0]) {
            loadAnalytics();
            await load(storeModule.env.RecaptchaSiteKey);
            new Vue({
                router,
                store,
                render: (h) => h(App),
            }).$mount('#app');
        } else {
            setAppLoadingMessage(
                `Load Error: ${res[1] || 'a unknown error occoured, please refresh to try again'}`,
                true);
        }
    } catch (err) {
        setAppLoadingMessage(`Load Error: ${'a unexpected error occoured, please refresh to try again'}`, true);
        // tslint:disable-next-line: no-console
        console.log(err);
    }
})();
